import { Polygon } from 'react-naver-maps';

export interface CustomPolygonProps {
  idx: number;
  paths: naver.maps.ArrayOfCoords[] | naver.maps.KVOArrayOfCoords[] | naver.maps.ArrayOfCoordsLiteral[];
  area_code: string;
  area_name: string;
  enableFlag?: boolean;
  selected?: boolean;
  click?: Function;
  mouseOver?: Function;
  mouseMove?: Function;
  mouseOut?: Function;
  over?: number;
}

export default function CustomPolygon(props: CustomPolygonProps) {
  return (
    <Polygon
      paths={props.paths}
      strokeWeight={props.enableFlag && props.idx === props.over ? 3 : 1}
      strokeColor={props.enableFlag && props.idx === props.over ? '#DD5555' : props.selected ? '#5555DD' : ''}
      strokeStyle="line"
      fillColor={props.enableFlag && props.idx === props.over ? '#FF4444' : props.selected ? '#4444FF' : ''}
      fillOpacity={props.enableFlag && props.idx === props.over ? 0.4 : props.selected ? 0.15 : 0}
      zIndex={props.enableFlag ? 3 : 2}
      onClick={() => props.click(props.area_code, props.area_name)}
      onMouseover={() => props.mouseOver(props.idx)}
      onMousemove={(e) => props.mouseMove({ name: props.area_name, position: e.coord })}
      onMouseout={() => props.mouseOut()}
      clickable
    />
  );
}
